import {
    faGlobe,
    faHeadphones,
    faHistory,
    faUser,
} from "@fortawesome/free-solid-svg-icons";

import "./styles.css";
import Tabs from "../../Utils/Tabs";
import { useMemo } from "react";
import ComponenteHistoricoCliente from "./ComponenteHistoricoCliente";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import ComponenteHistoricoUAU from "./ComponenteHistoricoUAU";
import ComponenteHistoricoCaso from "./ComponenteHistoricoCaso";
import { useUserInfor } from "../../../Context/User";
import ComponenteHistoricoLigacoes from "./ComponenteHistoricoLigacoes";
import { useHistoricoContext } from "../../../Context/Historico";

interface IPropsHistoricoCliente {
    ID_CASO?: number;
    ID_CHAVE_ERP?: string;
}

export default function HistoricoClienteCobranca(
    props: IPropsHistoricoCliente
) {
    const { TIPO_CASO } = useAtendimentoPage();
    const { ID_CONTA } = useHistoricoContext();
    const { OrgInfor } = useUserInfor();

    const showTipoContato = TIPO_CASO === "Cobranca";
    const divHeight = props.ID_CASO ? 400 : 500;

    const memoTabs = useMemo(() => {
        const tabs = [
            {
                Component: () => (
                    <ComponenteHistoricoCliente
                        ID_CASO={props.ID_CASO}
                        showTipoContato={showTipoContato}
                        height={divHeight}
                    />
                ),
                icon: faUser,
                name: "Histórico do Cliente",
                key: "#cliente",
            },
        ];
        if (props.ID_CASO)
            tabs.unshift({
                Component: () => (
                    <ComponenteHistoricoCaso
                        ID_CASO={props.ID_CASO}
                        showTipoContato={showTipoContato}
                        height={divHeight}
                    />
                ),
                icon: faHistory,
                name: "Histórico do Caso",
                key: "#caso",
            });
        if (props.ID_CHAVE_ERP && OrgInfor.COD_ERP_INTEGRACAO === "UAU") {
            tabs.push({
                Component: () => (
                    <ComponenteHistoricoUAU
                        ID_CHAVE_ERP={props.ID_CHAVE_ERP ?? ""}
                        height={divHeight}
                    />
                ),
                icon: faGlobe,
                name: "Histórico UAU",
                key: "#uau",
            });
        }
        tabs.push({
            Component: () => (
                <ComponenteHistoricoLigacoes
                    idConta={ID_CONTA}
                    height={divHeight}
                />
            ),
            icon: faHeadphones,
            name: "Histórico de Ligações",
            key: "#ligacoes",
        });

        return tabs;
    }, [
        props.ID_CHAVE_ERP,
        props.ID_CASO,
        showTipoContato,
        OrgInfor.COD_ERP_INTEGRACAO,
        ID_CONTA,
        divHeight,
    ]);

    return (
        <>
            {memoTabs.length > 1 ? (
                <Tabs
                    tabs={memoTabs}
                    inicial="#caso"
                    cardClasses={
                        props.ID_CASO
                            ? "card card-custom pt-2 pl-2 pb-4"
                            : "p-3"
                    }
                />
            ) : (
                <div
                    className="card card-custom card-stretch pt-0"
                    style={{ minHeight: divHeight }}
                >
                    <h3 className="font-weight-bolder p-5 m-0 border-bottom">
                        Histórico do Cliente
                    </h3>
                    <ComponenteHistoricoCliente
                        ID_CASO={props.ID_CASO}
                        showTipoContato={showTipoContato}
                    />
                </div>
            )}
        </>
    );
}
